
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-61f87e2a\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!sass-resources-loader?{\"resources\":[\"/root/workspace/platform-admin_Cbe5/src/style/theme.scss\",\"/root/workspace/platform-admin_Cbe5/src/style/_mixin.scss\"]}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./home.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./home.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-61f87e2a\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./home.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "/root/workspace/platform-admin_Cbe5/src/view/home.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] home.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-61f87e2a", Component.options)
  } else {
    hotAPI.reload("data-v-61f87e2a", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/view/home.vue
// module id = 335
// module chunks = 30